
import { defineComponent, reactive, computed } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { useStore } from 'vuex'
import AppInput from '../atoms/AppInput.vue'
import ButtonIcon from '../molecules/ButtonIcon.vue'
import { LoginRequest } from '@/data/@types/LoginRequest'
import { MUTATIONS } from '@/store/mutations-types'

export default defineComponent({
  components: {
    AppInput,
    ButtonIcon
  },
  setup () {
    const router = useRouter()
    const route = useRoute()
    const store = useStore()

    const form = reactive<LoginRequest>({ cardId: '', password: '' })
    const errorMessage = computed(() => {
      return store.getters.errorTextInLoginPage
    })
    const hasError = computed(() => {
      return store.getters.hasErrorInLoginPage
    })
    const login = async () => {
      const data = new FormData()
      data.append('cardId', form.cardId)
      data.append('password', form.password)
      await store.dispatch('builtinLogin', data)
      if (!hasError.value) {
        store.commit(MUTATIONS.LOGIN_NOTIFICATION)

        const isRekion = route.meta.isRekion
        const loggedInUser = store.getters.loggedInUser
        if (isRekion && loggedInUser.role?.includes('REKION_ADMIN')) {
          router.push('/manage')
          return
        }
        router.push('/')
      }
    }

    return {
      login,
      form,
      errorMessage,
      hasError
    }
  }
})
